export default "__VITE_ASSET__PR72f_jx__"